<body class="bg-gray-100 font-sans">
  <app-header></app-header>

  <!-- Banner Section -->
  <div class="relative w-full h-[400px] flex justify-center items-center">
    <img
      src="assets/TrailFusion/banner-explore.jpg"
      alt="FAQ banner"
      class="absolute inset-0 w-full h-full object-cover brightness-75"
    />
    <div class="relative text-white text-center px-4 animate-fade-in">
      <h1 class="text-4xl font-extrabold">Frequently Asked Questions</h1>
      <p class="text-lg mt-2 font-semibold">
        Everything you need to know about TrailFusion
      </p>
    </div>
  </div>

  <!-- Main FAQ Section -->
  <div class="container-custom mt-12 mb-16">
    <section class="py-8">
      <h2
        class="text-3xl font-bold text-center text-gray-800 mb-10 animate-fade-in"
      >
        Your Questions Answered
      </h2>

      <div class="max-w-4xl mx-auto space-y-6">
        <!-- FAQ Item -->
        <div
          class="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition animate-fade-in-up"
        >
          <h3 class="text-xl font-semibold text-gray-800">
            ❓ How do I register for a program?
          </h3>
          <p class="mt-2 text-gray-600 leading-relaxed">
            You can register by browsing through our programs, selecting the one
            that interests you, and clicking on the "Register" button. Fill in
            your details, complete the payment, and you’re all set!
          </p>
        </div>

        <!-- FAQ Item -->
        <div
          class="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition animate-fade-in-up delay-100"
        >
          <h3 class="text-xl font-semibold text-gray-800">
            💳 What payment methods do you accept?
          </h3>
          <p class="mt-2 text-gray-600 leading-relaxed">
            We currently accept payments via major credit/debit cards and secure
            online gateways. All payments are processed safely.
          </p>
        </div>

        <!-- FAQ Item -->
        <div
          class="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition animate-fade-in-up delay-200"
        >
          <h3 class="text-xl font-semibold text-gray-800">
            📅 Can I cancel or reschedule after registering?
          </h3>
          <p class="mt-2 text-gray-600 leading-relaxed">
            Yes! You can manage your registrations in your account dashboard. If
            you need help, contact our support team and they’ll assist you with
            cancellations or reschedules.
          </p>
        </div>

        <!-- FAQ Item -->
        <div
          class="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition animate-fade-in-up delay-300"
        >
          <h3 class="text-xl font-semibold text-gray-800">
            🧾 Will I get a confirmation after registering?
          </h3>
          <p class="mt-2 text-gray-600 leading-relaxed">
            Absolutely! Once your registration is complete, you’ll receive a
            confirmation email with all details, including program dates and
            payment receipt.
          </p>
        </div>
      </div>
    </section>
  </div>

  <app-footer></app-footer>
</body>
